module.exports = __webpack_public_path__ + "img/chevron-4.62fee60e.jpg";